<script setup lang="ts">
import { type Component, computed } from 'vue'
import type { Page } from '@bloomreach/spa-sdk'
import { useBackground } from '../../composables/useBackground'
import type { IBackground } from '@/cms-ui/ts/interfaces/IBackground'

const props = withDefaults(
    defineProps<{
        page: Page
        background?: IBackground
        is?: 'div' | 'section' | 'button' | 'a' | Component
    }>(),
    {
        is: 'section',
    },
)

const { backgroundProperties } = useBackground(props.page, props.background)

const backgroundStyles = computed(() => ({
    '--mobile-bg': backgroundProperties.mobile ? `url(${backgroundProperties.mobile})` : 'none',
    '--tablet-bg': backgroundProperties.tablet ? `url(${backgroundProperties.tablet})` : 'none',
    '--desktop-bg': backgroundProperties.desktop ? `url(${backgroundProperties.desktop})` : 'none',
    '--bg-size': backgroundProperties.backgroundSize || 'cover',
    '--bg-color': backgroundProperties.backgroundColor || 'transparent',
}))
</script>

<template>
    <component
        :is="is"
        class="background-wrapper"
        :style="backgroundStyles"
    >
        <slot />
    </component>
</template>

<style scoped>
.background-wrapper{background-color:var(--bg-color);background-position:50%;background-repeat:no-repeat;background-size:var(--bg-size);width:100%}@media (max-width:767px){.background-wrapper{background-image:var(--mobile-bg)}}@media (min-width:768px) and (max-width:1023px){.background-wrapper{background-image:var(--tablet-bg)}}@media (min-width:1024px){.background-wrapper{background-image:var(--desktop-bg)}}
</style>
